// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1kbGW","left":"InfoRow_left__1_dP7"};